export const VIEW_AS_UNAVAILABLE_MESSAGE =
  'View As is not available for your account.';
export const VIEW_AS_SELF_MESSAGE = "You can't view as your own account";

/**
 * normalizes the requester's view-as permission fields from the agent profile
 * @param zohoData - agent profile from state.user.zohoData (fields always describe the requester, even mid view-as)
 */
export function getViewAsPermissions(zohoData) {
  const allowedFor = Array.isArray(zohoData?.vaAllowedFor)
    ? zohoData.vaAllowedFor
    : [];
  const notAllowedReason =
    typeof zohoData?.vaNotAllowedReason === 'string'
      ? zohoData.vaNotAllowedReason
      : '';

  return {
    allowedFor,
    canViewAs: allowedFor.length > 0,
    notAllowedReason
  };
}

/**
 * composes the disabled-reason tooltip for a view-as control; '' means enabled.
 * the downline check lives in the api, so the ui only knows about self and the requester's own permission
 * @param requesterZohoData - state.user.zohoData
 * @param isSelfTarget - target is the requester's own account
 */
export function getViewAsDisabledReason({ requesterZohoData, isSelfTarget }) {
  if (isSelfTarget) return VIEW_AS_SELF_MESSAGE;

  const { canViewAs, notAllowedReason } =
    getViewAsPermissions(requesterZohoData);

  if (!canViewAs) return notAllowedReason || VIEW_AS_UNAVAILABLE_MESSAGE;
  return '';
}

/**
 * true when an admin is viewing the portal as another agent (`?va=` or redux)
 * @param viewAsAgentId - state.user.viewAsAgent
 * @param search - location.search, defaults to the window's
 */
export function isViewingAsAgent(viewAsAgentId, search = '') {
  if (viewAsAgentId) return true;
  const query =
    search ||
    (globalThis.window === undefined ? '' : globalThis.window.location.search);
  return Boolean(new URLSearchParams(query).get('va'));
}

/**
 * appends ?va= to an internal link so sidebar navigation keeps the view-as session
 * @param to - internal path, optionally with query and hash
 * @param viewAsAgent - state.user.viewAsAgent
 */
export function withViewAsSearch(to, viewAsAgent) {
  if (!viewAsAgent || typeof to !== 'string') return to;

  const hashIndex = to.indexOf('#');
  const pathPart = hashIndex >= 0 ? to.slice(0, hashIndex) : to;
  const hashSuffix = hashIndex >= 0 ? to.slice(hashIndex) : '';

  const queryIndex = pathPart.indexOf('?');
  const pathname = queryIndex >= 0 ? pathPart.slice(0, queryIndex) : pathPart;
  const existingSearch = queryIndex >= 0 ? pathPart.slice(queryIndex + 1) : '';

  const params = new URLSearchParams(existingSearch);
  params.set('va', viewAsAgent);

  const qs = params.toString();
  return qs ? `${pathname}?${qs}${hashSuffix}` : `${pathname}${hashSuffix}`;
}
